import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionService } from '../session.service.js';
import { HttpParams } from "@angular/common/http";
import { PageEvent } from '@angular/material/paginator';
import { SortEvent } from 'allai-admin-shared';

/** Service that manages the appointments list filters to maintain their changes and reloading */
@Injectable({
	providedIn: 'root'
})
export class PatientsFilterService {

	/** Pager for list views */
	private _pageEvent: PageEvent;

	/** Global Search */
	private _globalSearch: string;

	/** Global Search */
	private _sortOrder: SortEvent;

	/** Subject for filter changes */
	private onNewFilterSubject: Subject<void> = new Subject<void>();

	constructor(private sessionService: SessionService) {
		//clear on login
		this.sessionService.onLogin.subscribe(() => this.clear());
	}

	/** Dispatch an event on a change */
	private setChanged(savePage?: boolean) {
		if (!savePage) {
			this._pageEvent = null;
		}
		this.onNewFilterSubject.next();
	}

	/** Clear all saved filters and {@link localStorage} */
	clear() {

	}

	set pageEvent(pageEvent: PageEvent) {
		this._pageEvent = pageEvent;
		this.setChanged(true);
	}

	get pageEvent(): PageEvent {
		if (!this._pageEvent) {
			this._pageEvent = {
				pageIndex: 0,
				pageSize: 10,
				length: 100
			}
		}
		return this._pageEvent;
	}

	set globalSearch(globalSearch: string) {
		this._globalSearch = globalSearch;
		this.setChanged();
	}

	get globalSearch(): string {
		if (!this._globalSearch) {
			this._globalSearch = '';
		}
		return this._globalSearch;
	}

	set sortOrder(sortOrder: SortEvent) {
		this._sortOrder = sortOrder;
		this.setChanged();
	}

	get sortOrder(): SortEvent {
		if (!this._sortOrder) {
			this._sortOrder = {
				active: '',
				direction: ''
			};
		}
		return this._sortOrder;
	}

	/** Dispatched for filter changes */
	get onNewFilter() {
		return this.onNewFilterSubject.asObservable();
	}

	get params(): HttpParams {
		let params: HttpParams = new HttpParams();

		const pageEvent = this.pageEvent;
		const sort: SortEvent = this.sortOrder;

		params = params.set("pageIndex", pageEvent.pageIndex);
		params = params.set("pageSize", pageEvent.pageSize);
		params = params.set("globalSearch", this.globalSearch);
		params = params.set("orderBy", sort.active);
		params = params.set("direction", sort.direction);
		return params;
	}
}
